module.exports = __webpack_public_path__ + "static/img/lb1.02acece.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/lb1.png
// module id = OiSX
// module chunks = 0